module.exports = __webpack_public_path__ + "img/spoken-training-test-report.5c7ba9cc.svg";